import * as React from "react";
const SvgLightningSolid = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M.38 11.939 9.327.499c.317-.406.965-.126.888.382l-.841 5.577h5.026a.3.3 0 0 1 .24.48L5.38 19.323c-.316.421-.984.132-.893-.386l1.139-6.514H.615a.3.3 0 0 1-.236-.485Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgLightningSolid;
